module.exports = __webpack_public_path__ + "static/media/marino.8733e0a2.jpg";